/**
 * KubernetesStatefulSet Model
 */
const _KubernetesStatefulSet = Object.freeze({
  Namespace: '',
  Name: '',
  StackName: '',
  ReplicaCount: 0,
  ImageModel: null,
  Env: [],
  CpuLimit: '',
  MemoryLimit: '',
  CpuRequest: '',
  MemoryRequest: '',
  VolumeMounts: [],
  Volumes: [],
  Secret: undefined,
  VolumeClaims: [],
  ServiceName: '',
  ApplicationName: '',
  ApplicationOwner: '',
  Note: '',
  Affinity: undefined, // KubernetesPodAffinity
  Annotations: [],
});

export class KubernetesStatefulSet {
  constructor() {
    Object.assign(this, JSON.parse(JSON.stringify(_KubernetesStatefulSet)));
  }
}
